import { useForm } from 'react-hook-form';

import { Button, Modal } from '../../components';

interface ModalWebsocketProps {
	close?: (...args: any[]) => void;
	title?: string;
	user?: string;
	pwd?: string;
	idPerfCognito?: any;
	oldIdPerfilCognito?: any;
	idProv?: any;
	oldIdProveedor?: any;
}

export const ModalWebsocket = ({
	close,
	title,
	user,
	pwd,
	idPerfCognito,
	oldIdPerfilCognito,
	idProv,
	oldIdProveedor,
}: ModalWebsocketProps) => {
	const hookForm = useForm();
	const { handleSubmit } = hookForm;

	void close;
	void title;
	void user;
	void pwd;
	void idPerfCognito;
	void oldIdPerfilCognito;
	void idProv;
	void oldIdProveedor;

	const mdlUsersAceptar = () => {
		window.location.assign('/');
	};

	// console.log(`Cerrando sesión del cliente por websocket at ${new Date()}`);

	return (
		<Modal className="" sizeWidth="450px">
			<h1 className="modal__title">Información</h1>
			<form onSubmit={handleSubmit(mdlUsersAceptar)} autoComplete="off">
				El estado del ejercicio ha sido actualizado por el administrador. Se
				cerrará la sesión actual
				<div className="modal__buttom">
					<Button type="submit" size="medium" text="Aceptar" />
				</div>
			</form>
		</Modal>
	);
};
